<ion-content [fullscreen]="true">
  <div id="reader"></div>

  <div class="qrcode-border"></div>
  <div class="qrcode-top-text">
    <ion-button (click)="closeModal()">
      <ion-icon name="chevron-back-outline"></ion-icon>
    </ion-button>
  </div>
  <div class="qrcode-bottom-text">Escaneie o código QR</div>
</ion-content>

